import { FieldError, UseFormRegisterReturn } from 'react-hook-form'
import TextField from '../../atoms/inputs/TextField'

type DocumentItemConstructionTypeFieldProps = {
  register?: UseFormRegisterReturn
  error?: FieldError
  disabled?: boolean
}

export default function DocumentItemConstructionTypeField({
  register,
  error,
  disabled,
}: DocumentItemConstructionTypeFieldProps) {
  return (
    <TextField
      register={register}
      placeholder="足場工事、塗装工事"
      size="sm"
      error={error?.message}
      readonly={disabled}
    />
  )
}
